module.exports = __webpack_public_path__ + "static/block4-e18a2f42b9c9785b5d056b43f961d630.jpg";